import { getCurrencyOptions } from '../../../../services/countryService';
import { ORDER_STATUS } from '../../../../constants/AppConstants';

export const currencyOptions = getCurrencyOptions().map((opt) => ({
  ...opt,
  id: String(opt.value)
}));

export const statusOptions = ORDER_STATUS.map((opt) => ({
  ...opt,
  id: opt.value
}));
